<template>
    <div class="layout-right" ref="layout-right">
        <div class="layout-right-top">
            <right-top bread="库存管理-库存列表"></right-top>
        </div>
        <div class="layout-right-body">
            <div class="item-box item-search">
                <search-box placeholder="产品名称或产品编码" :select-data="selectCategory" :btns="isMain ? searchOtherBtn : {}"
                            @click="addEvent" @search="searchEvent"
                ></search-box>
            </div>

            <div class="item-content" ref="itemContent">
                <div class="table-box">
                    <el-table :data="tableData" size="medium" ref="tableData" cell-class-name="table-ceil"
                              header-cell-class-name="table-ceil"
                    >
                        <el-table-column
                                prop="title"
                                label="产品名称"
                                width="130">
                        </el-table-column>
                        <el-table-column
                                prop="no"
                                label="产品编码"
                                width="150">
                        </el-table-column>
                        <el-table-column
                                prop="category"
                                label="产品类别"
                                width="80">
                        </el-table-column>
                        <el-table-column
                                prop="unit_name"
                                label="单位"
                                width="80" />
                        <el-table-column
                                prop="remind_num"
                                label="提醒"
                                width="80">
                        </el-table-column>
                        <el-table-column
                                prop="in_num"
                                label="入库数量"
                                width="80">
                        </el-table-column>
                        <el-table-column
                                prop="out_num"
                                label="出库数量"
                                width="80">
                        </el-table-column>
                        <el-table-column
                                prop="num"
                                label="当前库存"
                                width="80">
                        </el-table-column>
                        <el-table-column
                                prop="price"
                                label="销售价"
                                width="80">
                        </el-table-column>
                        <el-table-column label="操作" min-width="300">
                            <template slot-scope="scope">
                                <div class="option-box">
                                    <el-button
                                            size="mini"
                                            type="primary"
                                            @click="handleEdit(scope.$index, scope.row)"
                                            v-if="isMain || !isUnified"
                                    >编辑</el-button>
                                    <el-button
                                            size="mini"
                                            type="success"
                                            @click="handleStack(1, scope.row)"
                                    >入库</el-button>
                                    <el-button
                                            size="mini"
                                            type="warning"
                                            @click="handleStack(2, scope.row)"
                                    >出库</el-button>
                                    <el-button
                                            size="mini"
                                            type="danger"
                                            @click="handleDelete(scope.$index, scope.row)"
                                            v-if="isMain || !isUnified"
                                    >删除</el-button>
                                </div>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
            </div>
        </div>
        <div class="layout-right-bottom">
            <div class="page-box">
                <el-pagination
                        @size-change="pageSizeChange"
                        @current-change="pageCurrentChange"
                        :current-page="page.nowPage"
                        :page-sizes="page.pageSizes"
                        :page-size="page.pageSize"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="page.count">
                </el-pagination>
            </div>
        </div>

        <!--入库出库-->
        <stack-box :goods-info="stackGoods" :mode="stackMode" v-if="stackMode && stackGoods" @close="stackClose"></stack-box>
    </div>

</template>

<script>
    import obj from "@/js/obj";
    import Menu from "@/model/Menu";
    import SearchBox from "@/model/SearchBox";
    import StackBox from "@/model/StackBox";
    import RightTop from "@/model/RightTop";
    export default {
        name: "GoodsList",
        components: {RightTop, StackBox, SearchBox, Menu},
        data: () => ({
            selectCategory: {
                value: "",
                listData: [
                    // {
                    //     label: "选项1",
                    //     value: "1"
                    // }
                ]
            },
            searchValue: "",
            searchOtherBtn: [
                {
                    label: "添加产品"
                }
            ],
            page: {
                nowPage: 1,
                pageSize: 50,
                pageSizes: [50, 100, 200, 400],
                count: 0,
            },
            tableAttr:{
                width: "100%",
                height: "100%"
            },
            tableData: [],
            stackGoods: {},
            stackMode: 0,    //1 入库, 2 出库
        }),
        computed: {
            isMain(){
                return this.$store.state.chain_option.is_main;
            },
            isUnified(){
                return this.$store.state.chain_option.is_unified_manage;
            }
        },
        mounted: function(){
            this.$store.commit("setMenuId", "3-1");
            // obj.scrollbar(".item-content");

            this.loadCategory();
            this.loadListData();
        },
        methods: {
            //添加按钮点击
            addEvent: function () {
                this.$root.go("goods/goods_info");
            }

            //编辑
            ,handleEdit: function (index, rowData) {
                this.$root.go("goods/goods_info", {id: rowData.id});
            }

            //入库出库
            ,handleStack: function (mode, rowData) {
                this.stackMode = mode;
                this.stackGoods = rowData;
            }

            //删除商品
            ,handleDelete: function (index, rowData) {
                obj.messageBox.confirm("你确定要删除【"+ rowData.title+"】吗？", "删除警告")
                    .then(() => {
                        obj.postData("goods/del_data", {id: rowData.id}, function (res) {
                            if(res.errcode === 0){
                                obj.message.success("删除成功");
                                this.loadListData();
                            }else if(res.errcode > 0){
                                obj.message.error(res.errdesc);
                            } else {
                                obj.message.error("删除失败");
                            }
                        }.bind(this));
                    })
                    .catch(() => {
                        //取消
                    });
            }

            //关闭入库出库窗口
            ,stackClose: function (isReload) {
                this.stackMode = 0;
                this.stackGoods = {};
                if(isReload){
                    this.loadListData();
                }
            }

            //搜索事件
            ,searchEvent: function (data) {
                this.searchValue = data.keyword ? data.keyword : "";
                this.selectCategory.value = data.selectVal ? data.selectVal : "";
                this.loadListData();
            }

            //每页显示数量变化
            ,pageSizeChange: function (val) {
                this.page.pageSize = val;
                this.loadListData();
            }

            //当前页码变化
            ,pageCurrentChange: function (val) {
                this.page.nowPage = val;
                this.loadListData();
            }

            //加载分类
            ,loadCategory: function () {
                obj.postData("goods_category/get_list_data", {limit: 50}, function (res) {
                    if(res.errcode === 0){
                        let cate = [];
                        for(let i in res.data){
                            cate.push({
                                label: res.data[i].name,
                                value: res.data[i].id
                            });
                        }
                        this.selectCategory = {
                            listData: cate,
                            value: ""
                        };
                    }
                }.bind(this));
            }

            //加载列表数据
            ,loadListData: function () {
                let postData = {
                    page: this.page.nowPage,
                    limit: this.page.pageSize,
                    category: this.selectCategory.value,
                    keyword: this.searchValue
                };
                obj.postData("goods/list_data", postData, function (res) {
                    if(res.errcode === 0){
                        this.page.count = res.count;
                        this.tableData = res.data;
                    }else{
                        this.tableData = [];
                    }
                }.bind(this));
            }
        }
    }
</script>

<style scoped>
    .layout-right-body>.item-search{
        height: 72px;
    }
    .layout-right-body>.item-content>.table-box{
        border-top-left-radius: 5px;
        border-top-right-radius: 5px;
        border-bottom: none;
        background-color: #ffffff;
        overflow:hidden;
        padding: 5px 16px 0;
    }
    .page-box{
        padding: 10px 20px;
        background: #ffffff;
        border-bottom-left-radius: 5px;
        border-bottom-right-radius: 5px;
        border-top: 1px solid #ebedf0;
    }
    .layout-right-bottom{
        padding-top: 0px;
    }
</style>
